import {ETheme, EMenuIntro} from '@/constants/conf';
import {TranslateResult} from 'vue-i18n';


export interface IMainMenuItem {
    title?: TranslateResult;  // libellé dans le menu
    segment?: TranslateResult;  // segment d'url
    theme: ETheme; // theme de couleur de l'item
    pageTheme?: ETheme; // theme du logo + burger
    intro: EMenuIntro; // le type d'intro souhaitée pour l'apparition
    image?: string|IMainMenuItemI18N; // l'image de fond de litem (peut etre ajusté en fonction du marché)
    imageOffset?: string, // decalage  de l'image dans le menu : exemple : 20% center, 100px (correspond à la prop css background-position)
    imageScale?: string, // taille  de l'image dans le menu : exemple : 150%, cover (correspond à la prop css background-size)
    layout?: string, // couleur du layout placé sur l'image (correspond à la prop css background-color, utiliser rgba pour avoir une transparence)
    layoutIndex?: string, // mettre l'index du layout pour l'avoir devant ou derrière l'image
    pageComponent: string|IMainMenuItemI18N; // nom du composant qui sera chargé sur la page  (peut etre ajusté en fonction du marché)
}

export interface IMainMenuItemI18N {
    [key:string]: any; // Add index signature
}


export const mainMenu: Array<IMainMenuItem> = [   
    
    {
        pageComponent: 'Future',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Future_cover.jpg',
        imageOffset: 'left center',
        layout: 'rgba(0,0,0,0.2)',
    },
    {
        pageComponent: 'Pioneer_Chassard',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Pioneer_Chassard_cover.jpg',
        imageOffset: 'left 25% bottom',
        layout: 'rgba(0,0,0,0.1)',
    },
    {
        pageComponent: 'KeyReport',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'KeyReport_cover.jpg',
        imageOffset: 'left 40% bottom',
        layout: 'rgba(0,0,0,0.2)',
    },
    {
        pageComponent: 'Travel',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Travel_001.jpg',
        imageOffset: 'left',
        layout: 'rgba(0,0,0,0.2)',
    },
    {
        theme: ETheme.LIGHT,
        intro: EMenuIntro.POINTOFVIEW,
        image: {
            FR : 'Edito_Mathieu-Vedrenne_cover.jpg',
            UK : 'Edito_Mouhammed-Choukeir_cover.jpg',
            LU : 'Edito_Olivier-Lecler_cover.jpg',
            CH : 'Edito_Franck-Bonin_cover.jpg',
            MC : 'Edito_Nicolas-Feit_cover.jpg',
        },
        pageComponent: {
            FR : 'EditoFR',
            UK : 'EditoUK',
            CH : 'EditoCH',
            LU : 'EditoLU',
            MC : 'EditoMC',
        },
    },
    {
        pageComponent: 'Arty_Paris',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        image: 'Arty_Paris_cover.jpg',
        imageOffset: 'right 30% bottom',
    },
    {
        pageComponent: 'Pioneer_MartinRoland',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Pioneer_MartinRoland_cover.jpg',
        imageOffset: 'center top 25%',
    },
    {
        pageComponent: 'TrendingNow',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        image: 'TrendingNow_cover.jpg',
        imageOffset: 'center',
    },
    {
        pageComponent: 'Arty_Digital',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Arty_Digital_cover.jpg',
        imageOffset: 'left bottom',
    },
    {
        pageComponent: 'Profiting',
        theme: ETheme.DARK,
        intro: EMenuIntro.DEFAULT,
        image: 'Profiting_001.svg',
        imageScale: '80%',
        imageOffset: 'center',
        layout: '#f39a4a',
        layoutIndex: '-1',
    },
    {
        pageComponent: 'Back',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.POINTOFVIEW,
        image: 'Back_cover.jpg',
        imageOffset: 'center',
        layout: 'rgba(0,0,0,0.3)',
    },
    {
        pageComponent: 'Legal',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        layout: '#7ab6e2',
    },
];
